export const defaultStyles = {
  color: "var(--theme-website-color-text-primary)",
  backgroundColor: "var(--theme-website-color-background-secondary)",
  borderColor: "var(--theme-website-color-border-primary)",
  borderRadius: {
    border_left_top_radius: "1",
    border_left_bottom_radius: "1",
    border_right_top_radius: "1",
    border_right_bottom_radius: "1",
  },
  fontWeight: "400",
  fontSize: "0.875",
  textTransform: "none",
  padding: {
    paddingTop: "0.35",
    paddingBottom: "0.35",
    paddingLeft: "1",
    paddingRight: "1",
  },
} as const;
